import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { Loader } from '../../../../components/Loader';
import { Dropdown } from '../../../../components/Dropdown';
import { Input } from '../../../../components/Input';
import { initiateNewVehicleValue, setNewVehicleValue } from '../../actions';
import { selectWork } from '../../../Api/selectors';
import { selectNewVehicle, selectNewVehicleValue } from '../../selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../constants';
import { BtwOrMarge } from '../../../Invoices/constants';
import { fixPriceFormat } from '../../../../utils/string';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { HBox } from '../../../../components/Box';
import { OnMouseOverNotification } from '../OnMouseOverNotification';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
dayjs.extend(customParseFormat);

import cn from 'classnames';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './Fields.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';

const Container = styled.div`
  margin-bottom: 24px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const DROPDOWN_OPTIONS = {
  vehicle_purpose: ['passenger', 'commercial'],
  sales_preferred_vehicle: [0, 1, 2, 3, 4, 5, 6]
    //convert to string
    .map(n => n + ''),
};

const STATE = {
  value: '',
  email_manual: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCardSalesFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  componentDidUpdate(prevProps, prevState) {}

  isCheckbox() {
    return (
      ['sell_with_license_plate', 'sell_without_license_plate', 'fix_damages', 'dont_fix_damages', 'tax_type'].indexOf(
        this.props.type,
      ) > -1
    );
  }

  isDropBox() {
    return ['sales_preferred_vehicle', 'tax_type', 'vehicle_purpose'].indexOf(this.props.type) > -1;
  }

  dropdown() {
    const type = this.props.type;

    const vals = DROPDOWN_OPTIONS[type];

    const options = vals.map(val => ({
      label: this.lbl(`vehicle.property.${type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.props.values[type]);

    return (
      <div className={styles.container}>
        <Dropdown
          className={styles.dropdown}
          controlClassName={'dropdown-card'}
          options={options}
          value={value}
          onChange={pair => this.props.setValue(pair.value)}
        />
      </div>
    );
  }

  checkbox() {
    const type = this.props.type;

    let isChecked = false;
    if ((type == 'sell_with_license_plate' || type == 'fix_damages') && this.props.value == 1) {
      isChecked = true;
    }
    if (type == 'sell_without_license_plate' && this.props.values?.sell_with_license_plate == '0') {
      isChecked = true;
    }

    if (type == 'dont_fix_damages' && this.props.values?.fix_damages == '0') {
      isChecked = true;
    }

    if (type == 'tax_type') {
      return (
        <HBox left vCenter gap={10}>
          <CheckboxComponent
            label={'BTW'}
            checked={this.props.values?.tax_type == 'BTW'}
            onChange={() => {
              if (!this.props.isEdit) return;
              const value = 'BTW';

              // this.props.setValue(value);
            }}
          ></CheckboxComponent>
          <CheckboxComponent
            label={'MARGE'}
            checked={this.props.values?.tax_type == 'marge'}
            onChange={() => {
              if (!this.props.isEdit) return;
              const value = 'marge';

              // this.props.setValue(value);
            }}
          ></CheckboxComponent>
        </HBox>
      );
    }

    return (
      <CheckboxComponent
        label={this.props.label}
        onChange={() => {
          if (!this.props.isEdit) return;
          const value = this.props.values[type] === '1' ? '0' : '1';

          if (type == 'sell_with_license_plate' && value === '1') {
            this.props.setValue('0', 'sell_without_license_plate');
            this.props.setValue(value, type);

            return;
          }
          if (type == 'sell_without_license_plate' && value === '1') {
            this.props.setValue('0', 'sell_with_license_plate');
            this.props.setValue(value, type);
            return;
          }
          if (type == 'fix_damages' && value === '1') {
            this.props.setValue('0', 'dont_fix_damages');
            this.props.setValue(value, type);

            return;
          }
          if (type == 'dont_fix_damages' && value === '1') {
            this.props.setValue('0', 'fix_damages');
            this.props.setValue('', 'fix_damages_details');
            this.props.setValue(value, type);

            return;
          }
          this.props.setValue(value);
        }}
        checked={isChecked}
      ></CheckboxComponent>
    );
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return <>{children}</>;
    }
  }

  formFieldLabel() {
    if (this.props.type == 'send_to_email') return;
    return this.lbl(`vehicle.order.property.${this.props.type}`);
  }

  onChangeSalesPrice(type) {
    this._t = this.timeout(this.calculateSalesPrice.bind(this), 300, this._t);
  }

  calculateSalesPrice() {
    const values = this.props.values;
    const type = this.props.type;
    const taxType = this.props.values?.tax_type;
    const vehiclePurpose = this.props.values?.vehicle_purpose;
    const isNew = this.props.values?.new_from_factory == '1';
    const isImport = this.props.values?.import;
    let restBpmForCalc = +values?.outgoing_rest_bpm || 0;
    const taxYear = parseInt(this.props.values?.tax_year, 10);
    let restBPMApplicableForCommercial = isNaN(taxYear) || taxYear >= 2025;


    let financial_price_b2b_incl_vat_btpm = this.props.values?.financial_price_b2b_incl_vat_btpm;
    let financial_price_gross_incl_btw_bpm = this.props.values?.financial_price_gross_incl_btw_bpm;
    let financial_price_nett_excl_vat_bpm = this.props.values?.financial_price_nett_excl_vat_bpm;

    if (env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE) {
      restBpmForCalc = this.props.values.regplate ? +values?.outgoing_rest_bpm || 0 : +values?.indication_rest_bpm || 0;
    }

    // SCENARIO 1;

    if (taxType == BtwOrMarge.BTW && vehiclePurpose == 'passenger' && !isNew) {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = (+this.props.value || 0) - restBpmForCalc;
        financial_price_nett_excl_vat_bpm = financial_price_gross_incl_btw_bpm / 1.21;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = (+this.props.value || 0) / 1.21;
        financial_price_b2b_incl_vat_btpm = (+financial_price_nett_excl_vat_bpm || 0) * 1.21 + restBpmForCalc;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = (+this.props.value || 0) * 1.21 + restBpmForCalc;
        financial_price_gross_incl_btw_bpm = (+financial_price_b2b_incl_vat_btpm || 0) - restBpmForCalc;
      }
    }

    // SCENARIO 2;

    if (taxType == BtwOrMarge.BTW && vehiclePurpose == 'commercial' && !restBPMApplicableForCommercial) {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = (+this.props.value || 0) * 1.21;
        financial_price_nett_excl_vat_bpm = (+financial_price_gross_incl_btw_bpm || 0) / 1.21;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = (+this.props.value || 0) / 1.21;
        financial_price_b2b_incl_vat_btpm = +financial_price_nett_excl_vat_bpm || 0;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = +this.props.value || 0;
        financial_price_gross_incl_btw_bpm = (+financial_price_b2b_incl_vat_btpm || 0) * 1.21;
      }
    }

    // SCENARIO 3

    if (taxType == BtwOrMarge.BTW && vehiclePurpose == 'passenger' && isNew) {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = (+this.props.value || 0) - (+values?.financial_bpm_gross || 0);
        financial_price_nett_excl_vat_bpm = (+financial_price_gross_incl_btw_bpm || 0) / 1.21;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = (+this.props.value || 0) / 1.21;
        financial_price_b2b_incl_vat_btpm = (+financial_price_nett_excl_vat_bpm || 0) * 1.21 + +values?.financial_bpm_gross;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = (+this.props.value || 0) * 1.21 + +values?.financial_bpm_gross;
        financial_price_gross_incl_btw_bpm = (+financial_price_b2b_incl_vat_btpm || 0) - +values?.financial_bpm_gross;
      }
    }

    // SCENARIO 4

    if (taxType == BtwOrMarge.MARGE && vehiclePurpose == 'passenger' && !isNew) {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = (+this.props.value || 0) - restBpmForCalc;
        financial_price_nett_excl_vat_bpm = +financial_price_gross_incl_btw_bpm || 0;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = +this.props.value || 0;
        financial_price_b2b_incl_vat_btpm = (+financial_price_nett_excl_vat_bpm || 0) + restBpmForCalc;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = (+this.props.value || 0) + restBpmForCalc;
        financial_price_gross_incl_btw_bpm = (+financial_price_b2b_incl_vat_btpm || 0) - restBpmForCalc;
      }
    }

    // SCENARIO 5
    if (taxType == BtwOrMarge.MARGE && vehiclePurpose == 'commercial') {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = +this.props.value || 0;
        financial_price_nett_excl_vat_bpm = +financial_price_gross_incl_btw_bpm || 0;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = +this.props.value || 0;
        financial_price_b2b_incl_vat_btpm = +financial_price_nett_excl_vat_bpm || 0;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = +this.props.value || 0;
        financial_price_gross_incl_btw_bpm = +financial_price_b2b_incl_vat_btpm || 0;
      }
    }

    // SCENARIO 6

    if (taxType == BtwOrMarge.MARGE && vehiclePurpose == 'passenger' && isNew) {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = (+this.props.value || 0) - +values?.financial_bpm_gross;
        financial_price_nett_excl_vat_bpm = +financial_price_gross_incl_btw_bpm || 0;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = +this.props.value || 0;
        financial_price_b2b_incl_vat_btpm = (+financial_price_nett_excl_vat_bpm || 0) + +values?.financial_bpm_gross;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = (+this.props.value || 0) + +values?.financial_bpm_gross;
        financial_price_gross_incl_btw_bpm = (+financial_price_b2b_incl_vat_btpm || 0) - +values?.financial_bpm_gross;
      }
    }

    // SCENARIO 7
    if (taxType == BtwOrMarge.BTW && vehiclePurpose == 'commercial' && !!restBPMApplicableForCommercial) {
      if (type == 'financial_price_b2b_incl_vat_btpm') {
        financial_price_gross_incl_btw_bpm = ((+this.props.value || 0) - restBpmForCalc) * 1.21;
        financial_price_nett_excl_vat_bpm = (+this.props.value || 0) - restBpmForCalc;
      }

      if (type == 'financial_price_gross_incl_btw_bpm') {
        financial_price_nett_excl_vat_bpm = (+this.props.value || 0) / 1.21;
        financial_price_b2b_incl_vat_btpm = financial_price_nett_excl_vat_bpm + restBpmForCalc;
      }

      if (type == 'financial_price_nett_excl_vat_bpm') {
        financial_price_b2b_incl_vat_btpm = (+this.props.value || 0) + restBpmForCalc;
        financial_price_gross_incl_btw_bpm = (+this.props.value || 0) * 1.21;
      }
    }

    this.props.setValue(fixPriceFormat(financial_price_b2b_incl_vat_btpm), 'financial_price_b2b_incl_vat_btpm');
    this.props.setValue(fixPriceFormat(financial_price_gross_incl_btw_bpm), 'financial_price_gross_incl_btw_bpm');
    this.props.setValue(fixPriceFormat(financial_price_nett_excl_vat_bpm), 'financial_price_nett_excl_vat_bpm');

    return;
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <>{this.wrap(this.renderField())}</>;
  }

  renderField() {
    // if (this.props.value === undefined) return null;

    if (this.isCheckbox()) {
      return this.checkbox();
    }

    if (this.isDropBox()) {
      return this.dropdown();
    }

    switch (this.props.type) {
      case 'financial_price_b2c':
        return (
          <input
            className="form-control"
            value={this.props.value}
            onChange={evt => {
              this.props.setValue(evt.target.value);
            }}
          />
        );

      case 'HILT_appraise_sum':
        return (
          <input
            className="form-control"
            value={this.props.value}
            onChange={evt => {
              this.props.setValue(evt.target.value);
            }}
          />
        );

      case 'HILT_bid_sum':
        return (
          <input
            className="form-control"
            value={this.props.value}
            onChange={evt => {
              this.props.setValue(evt.target.value);
            }}
          />
        );

      case 'financial_price_b2b_incl_vat_btpm':
        return (
          <div className={styles.inputButton}>
            <input
              className="form-control"
              value={this.props.value}
              onChange={evt => {
                this.props.setValue(evt.target.value);
              }}
            />
            <div style={{ width: '70px' }}>
              <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.onChangeSalesPrice(this.props.type)}>
                <FontAwesomeIcon icon={faCalculator} size="lg" />
              </ButtonComponent>
            </div>
          </div>
        );
      case 'financial_price_gross_incl_btw_bpm':
        return (
          <div className={styles.inputButton}>
            <input
              className="form-control"
              value={this.props.value}
              onChange={evt => {
                this.props.setValue(evt.target.value);
              }}
            />
            <div style={{ width: '70px' }}>
              <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.onChangeSalesPrice(this.props.type)}>
                <FontAwesomeIcon icon={faCalculator} size="lg" />
              </ButtonComponent>
            </div>
          </div>
        );
      case 'financial_price_nett_excl_vat_bpm':
        return (
          <div className={styles.inputButton}>
            <input
              className="form-control"
              value={this.props.value}
              onChange={evt => {
                this.props.setValue(evt.target.value);
              }}
            />
            <div style={{ width: '70px' }}>
              <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.onChangeSalesPrice(this.props.type)}>
                <FontAwesomeIcon icon={faCalculator} size="lg" />
              </ButtonComponent>
            </div>
          </div>
        );
      case 'outgoing_rest_bpm':
        return (
          <>
            <input
              className="form-control"
              value={this.props.value}
              onChange={evt => {
                this.props.setValue(evt.target.value);
              }}
            />
            {this.props.vehicle?.taxiVerleden === '1' && (
              <OnMouseOverNotification message={this.lbl('alert.is_taxi_tax_message')} />
            )}
          </>
        );
      case 'rest_bpm_export':
        let value = env.clientId == AppClientId.AUTOWIENTJES ? this.props.value || '€ 0.00' : this.props.value;
        return (
          <HBox vCenter>
            <input
              disabled={true}
              className="form-control"
              value={value}
              onChange={evt => {
                this.props.setValue(evt.target.value);
              }}
            />

            <OnMouseOverNotification message={this.lbl('alert.rest_bpm_export_tax_message')} />
          </HBox>
        );
      case 'catalogprice_incl_options':
        return (
          <input
            className="form-control"
            value={this.props.value}
            onChange={evt => {
              this.props.setValue(evt.target.value);
            }}
          />
        );
      // case 'delivery_costs':
      //   return (
      //     <Input
      //       className="card-input"
      //       value={this.props.value}
      //       onChange={evt => {
      //         this.props.setValue(evt.target.value);
      //       }}
      //     />
      //   );
      case 'fix_damages_details':
        return (
          <input
            disabled={this.props.values?.fix_damages == '0' || !this.props.values?.fix_damages}
            className="form-control"
            value={this.props.value}
            onChange={evt => {
              this.props.setValue(evt.target.value);
            }}
          />
        );
    }
  }
}

VehicleCardSalesFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },

    initiateValue() {
      dispatch(initiateNewVehicleValue(ownProps.type));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCardSalesField = compose(withConnect, withRouter)(VehicleCardSalesFieldComp);
